import React, { Component } from "react";

class Price extends Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className="price">
        <div className="price__priceContainer">
          <h3>price guarantee</h3>
          <ul>
            <li>
              <div>
                <p>
                  If you find (or are paying) a lower price on your medication
                  at another international prescription service (applies to
                  Canadian International Pharmacy Association certified
                  websites) within 14 days of your order – we promise to match
                  that lower price.
                </p>
              </div>
            </li>
          </ul>
          <img src="./assets/1.jpg" alt="" />
        </div>
      </div>
    );
  }
}

export default Price;



// WEBPACK FOOTER //
// ./src/components/Price/Price.js